import * as moment from "moment";


// These signatures are adapted from the ones declared for the moment() constructor.
function localDate(): localDate.LocalDate;
function localDate(timestamp: number): localDate.LocalDate;
function localDate(timestamp: Array<number>): localDate.LocalDate;
function localDate(timestamp: string, format?: moment.MomentFormatSpecification, strict?: boolean): localDate.LocalDate;
function localDate(timestamp: string, format?: moment.MomentFormatSpecification, language?: string, strict?: boolean): localDate.LocalDate;
function localDate(timestamp: Date): localDate.LocalDate;
function localDate(timestamp: moment.Moment): localDate.LocalDate;
function localDate(timestamp: Object): localDate.LocalDate;

function localDate(timestamp: any = moment()): localDate.LocalDate {
	if (arguments.length === 0)
		timestamp = moment();
	else if (!moment.isMoment(timestamp)) {
		// We got arguments, but the argument wasn't a moment. We must be trying to parse. Forward
		// all the arguments to the moment constructor.
		timestamp = moment.apply(null, arguments);
	}

	return {
		year: timestamp.year(),
		month: timestamp.month(),
		date: timestamp.date(),
	};
}


namespace localDate {
	export interface LocalDate {
		year: number;

		/** 0-based month */
		month: number;

		date: number;
	}

	export function utc() {
		return localDate(moment.utc());
	}
}

export = localDate;
